/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $flag from './_flag'
import * as $help from './help'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $maps from './_maps'
import * as $ubh from './_uniformboxheights'

var locationsThis: any
var propertyId: number = 0
var pageName: string = null
var pagePrefix: string = null
var map: any
var mapId: string
var coordsPrevSearchUrl: string = ''
var coordsSearchXhr: JQueryXHR = null
var clusterer: any
var ownersNotesUbh: $ubh.uniformBoxHeights

export function init($pageName, $pagePrefix, $propertyId, $locationsThis): void {
    pageName = $pageName
    pagePrefix = $pagePrefix
    propertyId = $propertyId
    locationsThis = $locationsThis
    mapId = $pagePrefix + '__map'

    $('.' + pagePrefix + '-searchexternalmaps').click(function () {
        $modal.load('/Property/ExternalLinksModal', { id: propertyId }, true, false, false)
    })

    $('.' + pagePrefix + '-district-icon').click(function () {
        $modal.show(
            '<a href="/Content/Data/Geographic/counties/' +
                $(this).attr('data-county') +
                '.jpg" target="_blank"><img src="/Content/Data/Geographic/counties/' +
                $(this).attr('data-county') +
                '.jpg" style="width:100%" /></a>',
            true,
            true,
            true
        )
    })

    $('.' + pagePrefix + '-transfer-details-link').click(function () {
        $modal.load(
            '/Default/TransferDetailsModal',
            { id: $(this).attr('data-id') },
            true,
            true,
            true
        )
    })

    $('.' + pagePrefix + '-fellings a').click(function (e) {
        $modal.load($(this).attr('data-link'), {}, false, true, true)
        e.preventDefault()
    })

    $('.' + pagePrefix + '-samtaxes a').click(function (e) {
        $modal.load($(this).attr('data-link'), {}, false, true, true)
        e.preventDefault()
    })

    var structheight = new $ubh.uniformBoxHeights({
        listElementsSelector: '.' + pagePrefix + '-structures .bcfla-box',
    })

    ownersNotesUbh = new $ubh.uniformBoxHeights({
        listElementsSelector: '.' + pagePrefix + '-ownersnotes .bcfla-box',
    })

    var clipboard = new ClipboardJS('.' + pagePrefix + '-lm-link-a')

    clipboard.on('success', function (e) {
        console.info('Action:', e.action)
        console.info('Text:', e.text)
        console.info('Trigger:', e.trigger)

        e.clearSelection()
    })

    clipboard.on('error', function (e) {
        console.error('Action:', e.action)
        console.error('Trigger:', e.trigger)
    })

    $('.' + pagePrefix + '-map-show-btn').click(function () {
        $('.' + pagePrefix + '-map-box').show()
        $('.' + pagePrefix + '-map-box-btn').hide()
        initMap()
    })

    $flag.bindToggleFlagEvents($('.' + pagePrefix + '-flags'))
    $help.tooltips.initializeTooltips($('.' + $pageName))
    $helpers.partialPageInit($('.' + $pageName))
}

export function setOwnersNotesRowHeight(): void {
    if (!ownersNotesUbh) return
    ownersNotesUbh.setHeights()
}

function initMap(): void {
    map = $maps.initMap({
        mapElement: $('.' + mapId),
        mapId: mapId,
        mapOptions: {
            zoom: 14,
            minZoom: 13,
        },
    })

    var boundsSearchFunction = _.debounce(function () {
        if (coordsSearchXhr) {
            console.log('coordsSearchXhr.abort')
            coordsSearchXhr.abort()
        }

        var bounds = map.getBounds()
        var coordsSearchUrl =
            '/Property/GetLocationsByBounds?north=' +
            bounds.getNorthEast().lat() +
            '&south=' +
            bounds.getSouthWest().lat() +
            '&east=' +
            bounds.getNorthEast().lng() +
            '&west=' +
            bounds.getSouthWest().lng() +
            '&excludeProperty=' +
            propertyId

        if (coordsSearchUrl === coordsPrevSearchUrl) {
            console.log('coordsSearchUrl samma som sist')
            return
        }

        console.log('coordsSearchUrl ' + coordsSearchUrl)
        coordsPrevSearchUrl = coordsSearchUrl

        coordsSearchXhr = $ajax.post({
            loadingText: 'Hämtar kringliggande fastigheter...',
            url: '/Property/GetLocationsByBounds',
            data: {
                north: bounds.getNorthEast().lat(),
                south: bounds.getSouthWest().lat(),
                east: bounds.getNorthEast().lng(),
                west: bounds.getSouthWest().lng(),
                excludeProperty: propertyId,
            },
            dataType: 'json',
            success: function (res) {
                $maps.clearMarkers(mapId)
                if (clusterer) clusterer.clearMarkers()

                var markerImages: { [color: string]: google.maps.MarkerImage } = {}

                $.each(res, function (idx, obj) {
                    var mrkimg = markerImages[obj.color]

                    if (!mrkimg || mrkimg === null || mrkimg === undefined) {
                        //console.debug("skapar ny marker " + obj.color);

                        markerImages[obj.color] = $maps.markerCircle(obj.color)
                        mrkimg = markerImages[obj.color]
                    } else {
                        //console.debug("hittat befintlig marker " + obj.color);
                    }

                    $maps.addMarker({
                        image: mrkimg,
                        location: new google.maps.LatLng(obj.lat, obj.lon),
                        map: map,
                        mapId: mapId,
                        no: 999 + idx,
                        onOver: function (marker) {
                            $('.' + pagePrefix + '__map-overlay').html(obj.desc)
                            $('.' + pagePrefix + '__map-overlay').show()
                        },
                        onOut: function (marker) {
                            $('.' + pagePrefix + '__map-overlay').hide()
                        },
                        onClick: function (marker) {
                            $modal.load(
                                '/Property/Details/' + obj.id + '?light=true',
                                {},
                                false,
                                true,
                                true
                            )
                        },
                    })
                })

                if (res.length > 100) {
                    clusterer = $maps.addClustering({
                        map: map,
                        mapId: mapId,
                    })
                }

                addMarkersThis(false)
            },
            complete: function () {
                coordsSearchXhr = null
            },
        })
    }, 500)

    google.maps.event.addListener(map, 'bounds_changed', function () {
        boundsSearchFunction()
    })

    addMarkersThis(true)
}

function addMarkersThis(setCenter: boolean): void {
    var bounds = new google.maps.LatLngBounds()

    $.each(locationsThis, function (idx, obj) {
        bounds.extend(new google.maps.LatLng(obj.lat, obj.long))

        $maps.addMarker({
            image: $maps.markerCircleRed,
            location: new google.maps.LatLng(obj.lat, obj.long),
            map: map,
            mapId: mapId,
            no: idx,
            onOver: function (marker) {
                $('.' + pagePrefix + '__map-overlay').html(obj.desc)
                $('.' + pagePrefix + '__map-overlay').show()
            },
            onOut: function (marker) {
                $('.' + pagePrefix + '__map-overlay').hide()
            },
        })
    })

    if (setCenter) {
        map.setCenter(bounds.getCenter())
    }
}
